import debounce from "lodash.debounce"
import { useCallback, useEffect, useState } from "react"

import Results from "./Results"

export default function SearchResultWrapper() {
  const [query, setQuery] = useState("")
  const hasQuery = query !== ""

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSetQuery = useCallback(
    debounce((value) => {
      setQuery(value)
    }, 500),
    []
  )

  function onSearchComplete() {
    setQuery("")
  }

  useEffect(() => {
    function handleSearchInputChanged(event) {
      const inputText = event.target.value
      if (inputText) {
        debouncedSetQuery(inputText)
      } else {
        onSearchComplete()
      }
    }

    document.addEventListener(
      "event-dispatcher:global-search-input",
      handleSearchInputChanged
    )

    return () => {
      document.removeEventListener(
        "event-dispatcher:global-search-input",
        handleSearchInputChanged
      )
    }
  })

  if (!hasQuery) return null
  return <Results query={query} onComplete={onSearchComplete} />
}
